import { User } from '../types'

export const getUserName = (user: User): string => {
  return user.preferredName !== '' ? user.preferredName : user.fullName ?? 'Anonymous'
}
